import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "href", "className", "type", "org", "lang"],
  _excluded2 = ["htmlProps"],
  _excluded3 = ["htmlProps"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"];
import { forwardRef, Fragment } from 'react';
import cn from 'classnames';
import parseClassnames from "../../helpers/parseClassnames";
import { getUserTagLabel } from "./utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserTag = function UserTag(_ref, ref) {
  var _Fragment;
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    typeProp = _ref.type,
    org = _ref.org,
    lang = _ref.lang,
    userTagProps = _objectWithoutProperties(_ref, _excluded);
  var type = !typeProp && org ? 'b2b' : typeProp || 'staff';
  var _getUserTagLabel = getUserTagLabel({
      type: type,
      lang: lang || 'es'
    }),
    userLabel = _getUserTagLabel.userLabel,
    textColor = _getUserTagLabel.textColor;
  var wrapperClassName = parseClassnames(className, cn('font-label', textColor, href || userTagProps.onClick ? 'cursor-pointer' : 'cursor-default'));
  var renderChildren = function renderChildren() {
    if (['b2b', 'b2b-admin', 'mentor'].includes(type) && org) {
      return _Fragment || (_Fragment = /*#__PURE__*/_jsxs(Fragment, {
        children: [userLabel, /*#__PURE__*/_jsx("span", {
          className: "ml-4 text-gray-dark",
          children: org
        })]
      }));
    }
    return userLabel;
  };
  if (as === 'a' || href) {
    var _ref2 = userTagProps,
      _htmlProps = _ref2.htmlProps,
      aProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: wrapperClassName
    }, _htmlProps), aProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'button' || userTagProps.onClick) {
    var _ref3 = userTagProps,
      _htmlProps2 = _ref3.htmlProps,
      buttonProps = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      type: "button",
      className: wrapperClassName
    }, _htmlProps2), buttonProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'label') {
    var _ref4 = userTagProps,
      _htmlProps3 = _ref4.htmlProps,
      labelProps = _objectWithoutProperties(_ref4, _excluded4);
    return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps3), labelProps), {}, {
      children: renderChildren()
    }));
  }
  var _ref5 = userTagProps,
    htmlProps = _ref5.htmlProps,
    spanProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: wrapperClassName
  }, htmlProps), spanProps), {}, {
    children: renderChildren()
  }));
};
export default /*#__PURE__*/forwardRef(UserTag);